import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { FileText } from "@fleet/icons";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { FinanceInvoices } from "@/features/finance/components/finance-invoices";

function FinanceInvoicesPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="4xl">
      <PageHeader title={t(msg`Invoices`)} backTo="/finance" icon={FileText} />
      <div class="mt-4">
        <FinanceInvoices />
      </div>
    </PageContainer>
  );
}

export const financeInvoicesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/finance/invoices",
  component: withFeatureGate("billing.core", FinanceInvoicesPage),
});
